import { gql } from "@apollo/client";

export const DeleteServiceReminder = gql`
    mutation DeleteServiceReminder ($id: ID!) {
        deleteServiceReminder (id: $id) {
            success
            message
        }
    }
`;
